import { ofertafirm } from "../OfertaFirmowa/ofertafirm";
import ServiceIllustration from "../../../ServiceIllustration";
import { Actions, Copy, Eyebrow, FirmIcons, Inner, Section, Split } from "./styled";

const firmGoals = [
  ["Samochód dla firmy", "Leasing samochodowy", "/leasing-samochodu"],
  ["Sprzęt lub maszyny", "Finansowanie wyposażenia", "/finansowanie-sprzetu-maszyn"],
  ["Środki na działalność", "Finansowanie obrotowe", "/finansowanie-obrotowe"],
  ["Rozwój przedsiębiorstwa", "Kredyt inwestycyjny", "/kredyt-inwestycyjny-dla-firmy"],
  ["Pieniądze z faktur", "Faktoring", "/faktoring-dla-firmy"],
];

export const FirmSection = () => <Section id="dla-firmy" $firm aria-labelledby="firma-title"><Inner>
  <Eyebrow>Dla przedsiębiorców</Eyebrow>
  <Split><Copy>
    <h2 id="firma-title">Finansowanie, które pomaga rozwijać firmę</h2>
    <p>Planujesz zakup samochodu, sprzętu albo inwestycję? Pomagamy porównać formy finansowania, uwzględniając wpłatę własną, miesięczne obciążenie i możliwości Twojej firmy.</p>
  </Copy><div><FirmIcons aria-label="Wybierz cel finansowania firmy">
    {ofertafirm.map(({ imgSrc }, index) => { const [goal, label, href] = firmGoals[index]; return <a key={goal} href={href}><img src={imgSrc} width="42" height="42" alt="" /><strong>{goal}</strong><small>{label} →</small></a>; })}
  </FirmIcons><Actions $firm><a href="/?source=formularz&topic=firma" data-contact-cta>Omów finansowanie swojej firmy →</a><a href="/finansowanie-firmy-leasing-suwalki">Poznaj dostępne rozwiązania →</a></Actions></div></Split>
</Inner></Section>;

export const FamilySection = () => <Section id="ubezpieczenie-zycie" $insurance aria-labelledby="ubezpieczenie-title"><Inner>
  <Eyebrow>Ochrona rodziny</Eyebrow>
  <Split><Copy>
    <h2 id="ubezpieczenie-title">Ubezpieczenie dopasowane do Twojej rodziny</h2>
    <p>Co stanie się z domowym budżetem, jeśli zabraknie dochodu lub pojawią się wydatki związane z chorobą? Pomagamy określić potrzebny zakres ochrony, uwzględniając zobowiązania, sytuację rodziny i możliwości finansowe.</p>
  </Copy><div>
    <FirmIcons aria-label="Możliwe obszary ochrony">
      {[["family", "Życie i rodzina", "zycie"], ["health", "Poważne zachorowanie", "choroba"], ["accident", "Skutki wypadków", "wypadek"], ["work", "Niezdolność do pracy", "praca"], ["rehab", "Rehabilitacja", "rehabilitacja"]].map(([type, label, id]) => <a key={type} href={`/ubezpieczenie-rodziny#${id}`}><ServiceIllustration type={type} size={42} /><small>{label} →</small></a>)}
    </FirmIcons>
    <p style={{ fontSize: 13, lineHeight: 1.5, opacity: .85 }}>Zakres świadczeń i wyłączenia zależą od wybranej polisy.</p>
    <Actions><a href="/?source=formularz&topic=ubezpieczenie-zycie" data-contact-cta>Porozmawiaj o ochronie →</a><a href="/ubezpieczenie-rodziny">Poznaj możliwości ubezpieczenia →</a></Actions>
  </div></Split>
</Inner></Section>;

const DodatkoweSciezki = () => <><FirmSection /><FamilySection /></>;
export default DodatkoweSciezki;
